/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_File_Downloaded_SuccessInputs */



/**
* | output |
* | --- |
* | "Subtitle file downloaded successfully" |
*
* @param {Subtitle_File_Downloaded_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_file_downloaded_success = /** @type {((inputs?: Subtitle_File_Downloaded_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_File_Downloaded_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fichier de sous-titres téléchargé avec succès")
	if (locale === "de") return /** @type {LocalizedString} */ ("Untertiteldatei erfolgreich heruntergeladen")
	if (locale === "it") return /** @type {LocalizedString} */ ("File dei sottotitoli scaricato correttamente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Файл субтитров успешно загружен.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Archivo de subtítulos descargado exitosamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("字幕文件下载成功")
	if (locale === "ja") return /** @type {LocalizedString} */ ("字幕ファイルが正常にダウンロードされました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सबटाइटल फ़ाइल सफलतापूर्वक डाउनलोड हो गई")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Arquivo de legenda baixado com sucesso")
	return /** @type {LocalizedString} */ ("Subtitle file downloaded successfully")
});